<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="grTestparameterses">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="工号">
            <el-input v-model.trim="filter.clientContractNo" clearable/>
          </vm-search>
          <vm-search label="PC号">
            <el-input v-model.trim="filter.workerNo" clearable/>
          </vm-search>
          <vm-search label="创建时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.startTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  style="width: 165px"
                  placeholder="选择开始时间"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endTime"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 165px"
                  placeholder="选择结束时间"/>
            </div>
          </vm-search>
          <vm-search label="柜体条码">
            <el-input v-model.trim="filter.barCode" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column fixed width="100" prop="clientContractNo" align="center" label="工号"/>
      <el-table-column fixed width="100" prop="workerNo" align="center" label="PC号"/>
      <el-table-column fixed prop="creatorName" width="100" align="center" label="测试员"/>
      <el-table-column fixed width="100" prop="barCode" align="center" label="柜体条码"/>
      <el-table-column fixed width="180" prop="createTime" align="center" label="测试时间"/>
      <el-table-column prop="testResult" align="center" label="测试结果">
        <template slot-scope="scope">
          <span v-if="scope.row.testResult">
            通过
          </span>
          <span v-else>
            失败
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="lighting" align="center" label="照明"/>
      <el-table-column prop="fan" align="center" label="风扇"/>
      <el-table-column prop="driver" align="center" label="司机"/>
      <el-table-column prop="nonStopLayer" align="center" label="不停层"/>
      <el-table-column prop="maintain" align="center" label="维护操作"/>
      <el-table-column prop="reverser" align="center" label="换向"/>
      <el-table-column prop="in1" align="center" label="IN1"/>
      <el-table-column prop="doorOpenButton" align="center" label="开门按钮"/>
      <el-table-column prop="doorCloseButton" align="center" label="关门按钮"/>
      <el-table-column prop="closeDoorDelay" align="center" label="关门延时"/>
      <el-table-column prop="petButton" align="center" label="宠物按钮"/>
      <el-table-column prop="iccard" align="center" label="IC卡"/>
      <el-table-column prop="fireVoice" align="center" label="消防语音"/>
      <el-table-column prop="tiringVoice" align="center" label="困人语音"/>
      <el-table-column prop="rescueVoice" align="center" label="救人语音"/>
      <el-table-column prop="powerCutVoice" align="center" label="停电语音"/>
      <el-table-column prop="alarmIntercom" align="center" label="警铃&对讲"/>
      <el-table-column prop="groundingDetection" align="center" label="接地检测"/>
      <el-table-column prop="versionQuery" align="center" label="版本查询"/>
      <el-table-column prop="instructSum" align="center" label="指令总数"/>
      <el-table-column prop="voiceStation" align="center" label="语音报站"/>
      <el-table-column prop="mainOperation" align="center" label="主操带残操"/>
      <el-table-column prop="controlBoxType" align="center" label="操纵箱类型"/>
      <el-table-column prop="testType" align="center" label="测试方式"/>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import KeyComponentEdit from "@/views/information/KeyComponent/KeyComponentEdit";
  export default {
    name: "",
    components: {VmTable,VmSearch},
    data() {
      return {
        idList: "",
        filter: {
          barCode: "",
          clientContractNo: "",
          workerNo: "",
          startTime: "",
          endTime: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
    },
  };
</script>

<style scoped>

</style>
